module.exports = __webpack_public_path__ + "static/media/social-plan.004cc07f.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/social-plan.png
// module id = 367
// module chunks = 0